import React, {Component} from 'react';

import hr from './hr.svg';

class AvatarShell extends Component {
  render() {
    return (
      <div
        className="Predictor-avatar-shell"
        onClick={() => this.props.handleAvatarClick(this.props.personID)}
        >
        <div className="Predictor-avatar">
          { this.props.personLabelSide ?
            <div className="Predictor-avatar-person-label-side">{this.props.personLabelSide}</div>
          : null }
          <div className="Predictor-avatar-person-label">{this.props.personLabel}</div>
          <div className="Predictor-avatar-color-label">Hair color:</div>
          <div className="Predictor-avatar-color-label-selection">{this.props.colorName ? this.props.colorName : 'UNDEFINED'}</div>
          <img className="hr small" src={hr} alt="" />
          {this.props.avatar}
        </div>
      </div>
    );
  }
}

export default AvatarShell;
